export const preferences = {
    communityId: 5,
}